<template>
  <v-sheet>
    <v-card outlined class="marco">
      <v-card-subtitle>
        <h4><strong>{{ $t('page.sectionEditor.late_penalties') }}</strong></h4>
      </v-card-subtitle>
      <v-card-text>
        <v-form ref="formLatePenalties">
          <v-row>
            <v-col cols="12" sm="12" xs="12">
              <v-switch
                    name="isLatePenalty"
                    dense
                    class="mt-0"
                    v-model="Section.raceSectionChecks[0].isLatePenalty"
                    :input-value="Section.raceSectionChecks[0].isLatePenalty"
                    :label="$t('page.sectionEditor.late_penalties')"
                    @change="updateFieldCheck('isLatePenalty', Section.raceSectionChecks[0].isLatePenalty)"
                    :true-value="1"
                    :false-value="0"
                    color="blue"
                    hide-details
              ></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                outlined dense
                v-model="Section.raceSectionChecks[0].penalties[1].withoutPenalty"
                @input="updateFieldPenalty('withoutPenalty', Section.raceSectionChecks[0].penalties[1].withoutPenalty)"
                :label="$t('page.sectionEditor.late_without_penalties')"
                :hint="$t('page.sectionEditor.late_without_penalties_lbl')"
                persistent-hint
                :rules="formatInvalidRules"
                onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Minus'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                outlined dense
                v-model="Section.raceSectionChecks[0].penalties[1].firstMinute"
                @input="updateFieldPenalty('firstMinute', Section.raceSectionChecks[0].penalties[1].firstMinute)"
                :label="$t('page.sectionEditor.first_minute')"
                :hint="$t('page.sectionEditor.first_minute_lbl')"
                persistent-hint
                :rules="formatInvalidRules"
                onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Minus'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                outlined dense
                v-model="Section.raceSectionChecks[0].penalties[1].nextMinute"
                @input="updateFieldPenalty('nextMinute', Section.raceSectionChecks[0].penalties[1].nextMinute)"
                :label="$t('page.sectionEditor.next_minute')"
                :hint="$t('page.sectionEditor.next_minute_lbl')"
                persistent-hint
                :rules="formatInvalidRules"
                onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Minus'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                outlined dense
                v-model="Section.raceSectionChecks[0].penalties[1].dsqMinute"
                @input="updateFieldPenalty('dsqMinute', Section.raceSectionChecks[0].penalties[1].dsqMinute)"
                :label="$t('page.sectionEditor.late-disqualification')"
                :hint="$t('page.sectionEditor.late-disqualification-lbl')"
                persistent-hint
                :rules="formatInvalidRules"
                  onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Minus'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-sheet>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";

export default {
  mixins: [apiCalls], //for api redundant operations
  props: ["Section"],
  components: {},
  data() {
    return {};
  },
  computed: {
    /*formatInvalidRules() {
      return [ (v) => {
        return (v || "").length == 0 || /^\d+$/.test(v) || this.$t('common.fomat_invalid_only_number');
      } ];
    },*/
    formatInvalidRules() {
      return [ 
        (v) => {
          const value = v ?? '';
          return this.$inputRules({ value }, 'filled') || this.$t('common.field-required')
        },
        (v) => {
          return this.$inputRules({ value: v }, 'nullable') || this.$inputRules({ value: v }, 'integer') || this.$t('common.fomat_invalid_only_number');
        } 
      ];
    },
    Check() {
      return this.Section.raceSectionChecks[0];
    },
    Penalty() {
      return this.Check.penalties[1];
    }
  },
  methods: {
    updateFieldPenalty(field, value) {
      let formData = {
        sectionId: this.Section.id,
        checkId: this.Check.id,
        penaltyId: this.Penalty.id,
        field,
        value
      };
      this.$store.dispatch('addSectionTimeCheckPenaltyUpdateAction', formData);
    },
    updateFieldCheck(field, value) {
      let formData = {
        sectionId: this.Section.id,
        checkId: this.Check.id,
        field,
        value
      };
      this.$store.dispatch('addSectionTimeCheckCheckUpdateAction', formData);
    }
  }
};
</script>